// extracted by mini-css-extract-plugin
export default {"filesContainer":"FileSystem_filesContainer__2cYkK","folder":"FileSystem_folder__sakDo","folderName":"FileSystem_folderName__Fg0MC","breadcrumbs":"FileSystem_breadcrumbs__wSukU"};